var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navigation-menu-item',{attrs:{"title":"חיסכון לטווח קצר","target":"balance-money","small":true},on:{"navigate":function($event){return _vm.$emit('navigate')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }